import { styled } from 'solid-styled-components';
import theme from '../../style/theme';

const {spacing, mediaQueries} = theme;

export const StyledProductSocial = styled.div`
    position: relative;
    z-index: 1;
    padding-top: ${spacing.m};

    ${mediaQueries.mobileMax} {
        padding-top: ${spacing.s};
    }
    @media print {
        display: none;
    }
`;

export const StyledShareContainer = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.7rem;
    cursor: pointer;

    p {
        transition: color 0.2s ease-in-out;
    }
    
    &:hover {
        svg {
            fill: ${theme.palette.primaryHover};
            stroke: ${theme.palette.primaryHover};
        }
        p {
            color: ${theme.palette.primaryHover};
        }
    }
`;
